module.exports = __webpack_public_path__ + "img/gunzenhausen_logo.c5dbbb5.png";